var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19065 17.1725C7.57771 16.7987 6.85399 16.6494 6.14315 16.75H4.33398V23.25H5.77482V20.7692H6.39232C7.03202 20.8349 7.67481 20.678 8.21232 20.325C8.66855 19.9337 8.9201 19.3547 8.89482 18.7542C8.9286 18.1443 8.66646 17.5555 8.19065 17.1725ZM7.03148 19.545C6.75934 19.6648 6.46013 19.7097 6.16482 19.675H5.74232V17.8333H6.16482C6.47161 17.8007 6.78112 17.8611 7.05315 18.0067C7.30649 18.1831 7.45006 18.4784 7.43232 18.7867C7.46514 19.0974 7.30672 19.3971 7.03148 19.545ZM11.9932 16.75H10.1948V23.25H11.9173C12.7952 23.3359 13.6791 23.1666 14.4632 22.7625C15.3258 22.1196 15.7867 21.0702 15.6765 20C15.7411 19.0831 15.4144 18.1817 14.7773 17.5192C13.9904 16.8989 12.9869 16.6217 11.9932 16.75ZM13.4232 21.7767C12.9718 22.0303 12.455 22.1435 11.939 22.1017H11.6573V17.8983H11.9173C12.8273 17.8983 13.1848 17.985 13.5423 18.31C13.9762 18.7617 14.2003 19.375 14.1598 20C14.2156 20.6764 13.9412 21.3381 13.4232 21.7767ZM17.2582 23.25H18.7207V20.5308H21.6673V19.3825H18.7207V17.8983H21.6673V16.75H17.2582V23.25ZM16.2507 2.66666H4.33398V14.5833H6.50065V12.4167V11.2792V4.83332H15.3515L19.5007 8.98249V11.2792V12.4167V14.5833H21.6673V8.08332L16.2507 2.66666Z",
    fill: "#D20A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c2b8a458c9a869b997c1af1a0242d3c9.svg";
export { ForwardRef as ReactComponent };